import './Subjects.scss';

const Subjects = () => {
  return (
    <section className="subjects" />
  );
};

export default Subjects;
